import Vue from 'vue';
import VueRouter from 'vue-router';
import entidadeRoute from '@/router/entidade';
import redefinirSenha from '@/router/redefinir-senha';
import loginRoute from './login';
import mainRoute from './main/main-router';
import googleAnalytcs from './google-analytics';

Vue.use(VueRouter);

const routes = [
  loginRoute,
  entidadeRoute,
  redefinirSenha,
  mainRoute,
  {
    path: '*',
    redirect: { name: 'login' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

if (process.env.VUE_APP_GA_KEY) {
  window.ga('create', process.env.VUE_APP_GA_KEY, 'auto');
  router.afterEach(googleAnalytcs);
}

export default router;
